import { BaSeSmall1, BaSeSmall2, BaSeTheme } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import {
  ColumnOne,
  ColumnTwo,
  ContainerFooter,
  FooterLine,
  FooterLoggedUser,
  FooterMenu,
  FooterWrapper,
  MenuItem,
} from './footer-styled';

export const LayoutFooter = () => {
  const { isAuthenticated } = Sebrae.useAuth();

  const menuItems = [
    {
      id: 1,
      name: 'O Sebrae',
      link: 'https://www.sebrae.com.br/sites/PortalSebrae/canais_adicionais/conheca_quemsomos',
    },
    { id: 2, name: 'O que fazemos', link: 'https://oqueosebraefaz.com.br/' },
    {
      id: 3,
      name: 'Transparência',
      link: 'https://transparencia.sebrae.com.br/mapa',
    },
    {
      id: 4,
      name: 'Agência Sebrae de Notícias',
      link: 'http://www.agenciasebrae.com.br/sites/asn',
    },
    {
      id: 5,
      name: 'Ouvidoria',
      link: 'https://www.sebrae.com.br/sites/PortalSebrae/ouvidoriasebrae',
    },
    { id: 6, name: 'Central de Relacionamento: 0800 570 0800', link: '' },
  ];

  return (
    <ContainerFooter isAuthenticated={isAuthenticated}>
      <FooterWrapper isAuthenticated={isAuthenticated}>
        {isAuthenticated ? (
          <>
            <FooterLine isAuthenticated={isAuthenticated} />
            <FooterLoggedUser>
              <ColumnOne>
                <BaSeSmall1
                  color={BaSeTheme.colors.institucionais.cinzaSebrae60}
                >{`Sebrae ${new Date().getFullYear()} - Todos os direitos reservados`}</BaSeSmall1>
              </ColumnOne>
              <ColumnTwo>
                <BaSeSmall2
                  color={BaSeTheme.colors.institucionais.cinzaSebrae75}
                >{`Gestor Empretec versão ${process.env.REACT_APP_VERSION}`}</BaSeSmall2>
              </ColumnTwo>
            </FooterLoggedUser>
          </>
        ) : (
          <>
            <FooterMenu>
              {menuItems.map((menu) => (
                <MenuItem key={menu.id}>
                  {menu.id !== 6 ? (
                    <a href={menu.link}>
                      <BaSeSmall1 color="#FFFFFF">{menu.name}</BaSeSmall1>
                    </a>
                  ) : (
                    <BaSeSmall1 color="#FFFFFF">{menu.name}</BaSeSmall1>
                  )}
                </MenuItem>
              ))}
            </FooterMenu>
            <FooterLine isAuthenticated={isAuthenticated} />
            <BaSeSmall1 color="#FFFFFF">
              Sebrae {new Date().getFullYear()} - Todos os direitos reservados
            </BaSeSmall1>
          </>
        )}
      </FooterWrapper>
    </ContainerFooter>
  );
};
